import { Controller } from "@hotwired/stimulus";

// Tabs hold the position they were opened in (KitController#remember_tab), so
// the active one can sit anywhere in a strip that scrolls. Scroll it into view
// on render — the visibility guarantee the old always-first ordering bought,
// without moving a tab out from under the cursor.
//
// Scrolls this element directly rather than calling scrollIntoView, which walks
// up the ancestors and would yank the page behind the panel.
//
// Also on the campaign tab row (partner_campaigns/_header_tabs), whose phone
// strip scrolls the same way: pass `data-kit-tabs-active-value=".item.active"`.
export default class extends Controller {
  static values = { active: { type: String, default: ".kit-tab--active" } };

  connect() {
    const active = this.element.querySelector(this.activeValue);
    if (!active) return;

    const left = active.offsetLeft;
    const right = left + active.offsetWidth;

    if (left < this.element.scrollLeft) {
      this.element.scrollLeft = left;
    } else if (right > this.element.scrollLeft + this.element.clientWidth) {
      // Clear the trailing padding too: on the campaign tabs it is the fade.
      const pad = parseFloat(getComputedStyle(this.element).paddingRight) || 0;
      this.element.scrollLeft = right - this.element.clientWidth + pad;
    }
  }
}
